import RafThrottle from '@utilities/raf-throttle';

const ELEMENT_TRIGGER_OFFSET_TOP = 0; // Offset position of the top edge of the element (0 - 1 out of element height)
const ELEMENT_TRIGGER_OFFSET_BOTTOM = 1; // Offset position of the bottom edge of the element (0 - 1 out of element height)
const WINDOW_TRIGGER_OFFSET = 0.7; // Offset position of the window trigger line (0 - 1 out of window height)
const wrapper = document.querySelector('body');
const content = document.querySelectorAll('[js-hook-background-component]');
let currentBackgroundEl = null;

class BackgroundChange {
  constructor(element) {
    this.element = element;
    this.setBackground();
    RafThrottle.set([
      {
        element: window,
        event: 'scroll',
        namespace: `BackgroundScroll${Math.random().toString(36).slice(10) + Date.now()}`,
        fn: this.setBackground.bind(this),
        delay: 5
      }
    ]);
    if (!wrapper.classList.contains('body-background-transition')) {
      wrapper.classList.add('body-background-transition');
    }
  }

  setBackground() {
    const elHeight = this.element.offsetHeight;
    const elOffset = this.element.getBoundingClientRect().top;
    const viewLine = document.documentElement.scrollTop + (window.innerHeight * WINDOW_TRIGGER_OFFSET); // The window trigger line
    
    // Trigger when the window view goes below this point
    const topEdge = (elOffset + document.documentElement.scrollTop) + (elHeight * ELEMENT_TRIGGER_OFFSET_TOP);
    
    // Trigger when the window view goes above this point
    const bottomLine = (elOffset + document.documentElement.scrollTop) + (elHeight *  ELEMENT_TRIGGER_OFFSET_BOTTOM);
    
    // Triggered, scrolled inside new element
    if (viewLine > topEdge && viewLine < bottomLine) {
      if (currentBackgroundEl !== this.element) {
        currentBackgroundEl = this.element;
        const backgroundColor = this.element.getAttribute('js-hook-background-change');
        const color = this.element.getAttribute('js-hook-text-change');

        content.forEach(node => node.classList.add('background-updated'));
        wrapper.style.setProperty('--background-update-color', color);
        
        if (backgroundColor) {
          wrapper.style.backgroundColor = backgroundColor;
        }
      }
    } else if (currentBackgroundEl === this.element) {
      // Reset when leaving element
      content.forEach(node => node.classList.remove('background-updated'));
      wrapper.style.backgroundColor = '';
      wrapper.style.removeProperty('--background-update-color');
      currentBackgroundEl = null;
    }
  }
}

export default BackgroundChange;
